export default __webpack_public_path__ + "static/media/oxo_face.97e4143b.png";